
<ng-container *ngIf="!isLogin; else loggedInTemplate">
    <div class="account-container">
        <div class="language-selection">
            <ng-container *ngTemplateOutlet="languageSelection"></ng-container>
        </div>
    </div>
    <div class="help-link-public">
        <a href="https://assistance.brgm.fr/aide/METEEAUNAPPES" target="_blank">
            <i class="pi pi-question-circle"></i> {{ 'MY_ACCOUNT.HELP' | translate }}
        </a>
    </div>
    <div class="login-link">
        <a (click)="loginUser()">
            <i class="pi pi-sign-in"></i> {{ 'MY_ACCOUNT.LOGIN' | translate }}
        </a>
    </div>
    
</ng-container>

<!-- Si l'utilisateur est connecté -->
<ng-template #loggedInTemplate>
    <div class="account-container">
        <div class="language-selection">
            <ng-container *ngTemplateOutlet="languageSelection"></ng-container>
        </div>
        <div class="user-info">
            <div>
                {{ userInfo?.nom }} {{ userInfo?.prenom }}
            </div>
            <div>
                {{ userInfo?.email }}
            </div>
        </div>
        <div class="redirection-container">
            <div class="update-link">
                <a (click)="editPassword()">
                    <i class="pi pi-pencil"></i> {{ 'MY_ACCOUNT.UPDATE' | translate }}
                </a>
            </div>
            <div class="help-link">
                <a href="https://assistance.brgm.fr/aide/METEEAUNAPPES" target="_blank">
                    <i class="pi pi-question-circle"></i> {{ 'MY_ACCOUNT.HELP' | translate }}
                </a>
            </div>
        </div>
    </div>
    
    <div class="login-link">
        <a (click)="logout()">
            <i class="pi pi-sign-out"></i> {{ 'MY_ACCOUNT.LOGOUT' | translate }}
        </a>
    </div>
</ng-template>

<!-- Template pour la sélection de langue -->
<ng-template #languageSelection>
    <button class="language-button" (click)="switchLanguage('fr')">
        <span class="flag-icon fi fi-fr"></span> Français
    </button>
    <button class="language-button" (click)="switchLanguage('en')">
        <span class="flag-icon fi fi-gb"></span> English
    </button>
</ng-template>